import React from "react";
import { Col, Container, Row, Table } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question: "Is this workshop suitable for beginners?",
    answer: `<p>Absolutely! We'll cover the basics and also provide advanced tips to enhance your plan.</p>`,
  },
  {
    question: "Will I receive any materials after the workshop?",
    answer: `<p>Yes, all attendees will receive a downloadable business plan template and other helpful resources.</p>`,
  },
  {
    question: "How can I join if I’m not in the same city?",
    answer: `<p>We will offer a virtual option so you can participate from anywhere in the world!</p>`,
  },
  
];

function FaqLocation(props) {
  return (
    <div className="faq_loc p-100 tekrevol_dark_bg home overflow-x-hidden">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div
              className="example example-bottom center text-center"
              data-text="FAQs"
            >
              <h2>Frequently Asked Questions</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
